module.exports = __webpack_public_path__ + "static/media/save.959c7549.svg";